import { LAYOUTS, ModalAlignmentEnum } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { WIDGET } from "@voltmoney/schema";
import { heightMap } from "../../configs/height";
import { ACTION } from "./types";
import { isMobile } from "../../configs/utils";
import { navigateToLeadScreen, onTrackPendingCustomerJourney } from "./action";
import { onSharePendingCustomerLink } from "../leads/actions";
export const template = (height, customerViewData, currentPage, currentActiveTabIndex, searchContext) => {
    return {
        layout: {
            id: ROUTE.PENDING_CUSTOMER_VIEW_DETAILS_SCREEN,
            type: LAYOUTS.MODAL,
            style: {
                isPartnerPlatform: true,
                height: isMobile() ? heightMap[ROUTE.PARTNER_VIEW_DETAIL_LEAD] : heightMap[ROUTE.CHECK_LIMIT_INFO],
                alignment: isMobile() ? ModalAlignmentEnum.BOTTOM : ModalAlignmentEnum.RIGHT
            },
            widgets: [{
                    id: 'pendingCustomerViewDetail',
                    type: WIDGET.PENDING_CUSTOMER_VIEW_DETAILS_SCREEN_DC,
                }],
        },
        datastore: {
            pendingCustomerViewDetail: {
                height: isMobile() ? heightMap[ROUTE.PARTNER_VIEW_DETAIL_LEAD] : height,
                customerViewData,
                trackPendingCustomerJourney: {
                    routeId: ROUTE.PENDING_CUSTOMER_VIEW_DETAILS_SCREEN,
                    type: ACTION.ON_TRACK_PENDING_CUSTOMER_JOURNEY,
                    payload: {},
                },
                shareLinkAction: {
                    routeId: ROUTE.PENDING_CUSTOMER_VIEW_DETAILS_SCREEN,
                    type: ACTION.SHARE_PENDING_CUSTOMER_LINK,
                    payload: {},
                },
                navigateToLeadScreenAction: {
                    routeId: ROUTE.PENDING_CUSTOMER_VIEW_DETAILS_SCREEN,
                    type: ACTION.NAVIAGTE_TO_LEAD_SCREEN,
                    payload: { currentPage, currentActiveTabIndex, searchContext },
                }
            },
        },
    };
};
export const pendingCustomerViewDetailScreen = {
    onLoad: async ({ network, getHeight }, { pendingCustomerData, currentPage, currentActiveTabIndex, searchContext }) => {
        return Promise.resolve(template(getHeight(), pendingCustomerData, currentPage, currentActiveTabIndex, searchContext));
    },
    actions: {
        [ACTION.ON_TRACK_PENDING_CUSTOMER_JOURNEY]: onTrackPendingCustomerJourney,
        [ACTION.SHARE_PENDING_CUSTOMER_LINK]: onSharePendingCustomerLink,
        [ACTION.NAVIAGTE_TO_LEAD_SCREEN]: navigateToLeadScreen
    },
};
